module.exports = __webpack_public_path__ + "static/media/01.63995778.png";